import { defineSlotRecipe } from '@chakra-ui/react';
import colors from '../colors';

function generateStripe(size = '1rem', color = 'rgba(255, 255, 255, 0.15)') {
  return {
    backgroundImage: `linear-gradient(
    45deg,
    ${color} 25%,
    transparent 25%,
    transparent 50%,
    ${color} 50%,
    ${color} 75%,
    transparent 75%,
    transparent
  )`,
    backgroundSize: `${size} ${size}`,
  };
}

const Progress = defineSlotRecipe({
  slots: ['root', 'track', 'range'],
  base: {
    root: {},
    // shows the current progress (variable width)
    range: {
      bg: 'podcastPurple500',
      borderRadius: '10px',
      height: '7px',
      transitionDuration: '0ms',
    },
    // track along which the range moves (always 100% width)
    track: {
      bg: 'podcastShade200',
      height: '7px',
      borderRadius: '100px',
      width: '100%',
      zIndex: '9',
    },
  },
  variants: {
    visual: {
      loading: {
        range: {
          ...generateStripe('1rem', 'rgba(0,0,0,0.1)'),
          bg: 'podcastShade300',
        },
      },
      turquoise: {
        range: {
          bg: 'podcastBlue600',
        },
      },
      purple: {},
      orange: {
        range: {
          bg: 'AlituOrange',
        },
      },
      grey: {
        range: {
          bg: 'podcastShade300',
        },
      },
      upload: {
        range: {
          height: '12px',
        },
        track: {
          maxWidth: '200px',
          height: '12px',
        },
      },
      miniPlayer: {
        track: {
          background: 'white',
        },
      },
      disabled: {
        track: {
          background: colors.podcastShade100,
          opacity: '0.8',
        },
      },
      clipGenie: {
        range: {
          height: '12px',
        },
        track: {
          height: '12px',
        },
      },
      comparison: {
        range: {
          h: '36px',
        },
        track: {
          h: '36px',
          w: '100%',
          background: colors.podcastPurple,
          div: {
            bg: `${colors.podcastBlue} !important`,
            borderRadius: 'none',
          },
        },
      },
      statistics: {
        range: {
          h: '36px',
        },
        track: {
          h: '36px',
          w: '580px',
          borderRadius: '10px',
        },
      },
      micVolume: {
        range: {
          h: '24px',
        },
        track: {
          h: '24px',
          borderRadius: '10px',
        },
      },
      participantVolume: {
        range: {
          h: '12px',
          borderRadius: '2px',
          background: `repeating-linear-gradient(
            to right,
            ${colors.podcastBlue},
            ${colors.podcastBlue} 2px,
            ${colors.podcastBlue600} 2px,
            ${colors.podcastBlue600} 4px
          );
          `,
        },
        track: {
          border: `2px solid ${colors.white}`,
          borderRadius: '4px',
          background: colors.white,
          h: '16px',
          w: '24px',
        },
      },
      studioVolume: {
        range: {
          h: '22px',
        },
        track: {
          border: `1px solid ${colors.podcastShade300}`,
          borderRadius: '10px',
          background: colors.white,
          h: '24px',
          w: '48px',
        },
      },
      volumeDisabled: {
        range: {
          h: '22px',
        },
        track: {
          border: `1px solid ${colors.podcastShade300}`,
          background: colors.podcastShade100,
          h: '24px',
          w: '48px',
          opacity: '0.5',
        },
      },
    },
  },
});

export default Progress;
